import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import i18n from "./plugins/i18n";
import "@/plugins/vant";

import "typeface-montserrat";
import "typeface-varela";

import "@/assets/styles.scss";
import "@fortawesome/fontawesome-free/css/all.css";
import "animate.css/animate.min.css";
import "./plugins/notification";

Vue.config.productionTip = false;

Vue.prototype.$b2_url = `https://f002.backblazeb2.com/file`;
Vue.prototype.$b2_initial_worter = `https://f002.backblazeb2.com/file/initial-worter`;
Vue.prototype.$b2_initial_images = `https://f002.backblazeb2.com/file/initial-images`;
Vue.prototype.$b2_users_media = `${Vue.prototype.$b2_url}/sprkr-user-uploads`;
Vue.prototype.$b2_tests_media = `${Vue.prototype.$b2_url}/tests-media`;

const app = new Vue({
  router,
  store,
  i18n,
  created() {
    this.$store.dispatch("account/getProfile", null, { root: true });
  },
  render: h => h(App)
});
store.$app = app;
app.$mount("#app");
